<template>
  <Modal :id="id" title="Clone Video">
    <div slot="body" class="modal-body">
      <p v-if="video">Are you sure you would like to clone the video titled: "{{ video.title }}"?</p>
      <form ref="form" method="post" :action="cloneRoute">
        <CsrfToken />
      </form>
    </div>
    <div slot="footer" class="modal-footer">
      <a class="btn btn-success" href="#" @click.prevent="submit">Continue</a>
      <a class="btn btn-info" href="#" @click.prevent="close">Cancel</a>
    </div>
  </Modal>
</template>

<script>
import ModalMixin from "mixins/Modal";
export default {
  mixins: [ModalMixin],
  data() {
    return {
      id: "clone-video-modal",
      video: null
    };
  },
  computed: {
    cloneRoute() {
      return this.video
        ? this.route("admin.videos.clone", { video: this.video.id })
        : "";
    }
  },
  methods: {
    submit() {
      this.$refs.form.submit();
    }
  },
  mounted() {
    this.video = this.options.video;
  }
};
</script>